import AppExport from '../../components/AppExport.vue';
import {Popup, popupDefaultCloseButton} from '../popup';

interface ExportOptions
{
    props: Partial<{
        askBeforeCreate: boolean
        withDescription: boolean
    }>,
    events: Partial<{
        onGenerated: (data: ExportSettings) => void
        onUpdated: (data: ExportSettings) => void
        onDeleted: (data: ExportSettings) => void
    }>
}

export function exportPopUp(exportData: ExportData, options?: Partial<ExportOptions>): Popup
{
    let popup = new Popup({
        title: 'Web-Export',
        size: 'medium',
        titleIcon: 'language',
        textIcon: '',
        textIconClass: 'text-grey',
        buttons: [popupDefaultCloseButton],
        component: AppExport,
        componentProps: Object.assign(
            {exportData},
            options?.props || {},
        ),
        events: options?.events as { [key: string]: Function } || {},
    });

    popup.open();

    return popup;
}